const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Plugin updates", "uipress-lite"),
  moduleName: "uip-plugin-updates",
  description: __("Outputs a list of available plugin and allows you update from the block", "uipress-lite"),
  group: "dynamic",
  icon: "upgrade",
};
